import type { SVGProps } from "react"

export const EmpoLogoComplete = ({
	title = "Empo logo complete",
	...props
}: SVGProps<SVGSVGElement> & {
	title?: string
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 1044 170.65"
		{...props}
	>
		<title>{title}</title>
		<path
			className="fill-mint-100"
			d="M368.94,60.77h21.17c11.28,0,16.26,6.3,16.26,14.8,0,7.91-4.25,13.19-12.09,14.65l13.85,18.46h-6.37l-12.97-18.17h-14.58v18.17h-5.27v-47.91ZM390.18,85.67c7.98,0,10.84-4.4,10.84-10.11s-2.86-9.96-10.84-9.96h-15.97v20.07h15.97Z"
		/>
		<path
			className="fill-mint-100"
			d="M408.57,90.58c0-10.99,8.06-19.05,19.49-19.05s19.34,8.06,19.34,19.05v1.61h-33.77c.66,7.55,6.3,12.89,14.43,12.89,5.71,0,10.11-2.34,12.45-6.52h5.35c-2.78,6.67-9.38,11.06-17.8,11.06-11.43,0-19.49-8.06-19.49-19.05ZM442.26,87.8c-1.17-7.33-6.89-11.72-14.21-11.72s-13.19,4.62-14.29,11.72h28.5Z"
		/>
		<path
			className="fill-mint-100"
			d="M450.98,87.51c0-10.77,6.3-15.97,14.65-15.97,5.86,0,10.7,2.78,13.04,8.13,2.27-5.35,7.11-8.13,13.04-8.13,8.35,0,14.65,5.2,14.65,15.97v21.17h-4.91v-21.17c0-7.69-4.25-11.43-10.11-11.43s-10.18,3.88-10.18,11.43v21.17h-4.91v-21.17c0-7.55-4.4-11.43-10.26-11.43s-10.11,3.74-10.11,11.43v21.17h-4.91v-21.17Z"
		/>
		<path
			className="fill-mint-100"
			d="M510.31,90.58c0-10.99,8.06-19.05,19.49-19.05s19.49,8.06,19.49,19.05-8.06,19.05-19.49,19.05-19.49-8.06-19.49-19.05ZM544.3,90.58c0-8.35-5.86-14.5-14.5-14.5s-14.5,6.15-14.5,14.5,5.86,14.5,14.5,14.5,14.5-6.15,14.5-14.5Z"
		/>
		<path
			className="fill-mint-100"
			d="M553.17,95.34v-35.68h4.91v12.82h21.32v4.47h-21.32v18.39c0,6.59,3.66,9.74,9.3,9.74s9.3-3.08,9.3-9.74v-.81h4.76v.81c0,9.52-5.71,14.29-14.07,14.29s-14.21-4.76-14.21-14.29Z"
		/>
		<path
			className="fill-mint-100"
			d="M584.08,90.58c0-10.99,8.06-19.05,19.49-19.05s19.34,8.06,19.34,19.05v1.61h-33.77c.66,7.55,6.3,12.89,14.43,12.89,5.71,0,10.11-2.34,12.45-6.52h5.35c-2.78,6.67-9.38,11.06-17.8,11.06-11.43,0-19.49-8.06-19.49-19.05ZM617.78,87.8c-1.17-7.33-6.89-11.72-14.21-11.72s-13.19,4.62-14.29,11.72h28.5Z"
		/>
		<path
			className="fill-mint-100"
			d="M646.49,60.77h5.27v21.17h31.06v-21.17h5.27v47.91h-5.27v-21.9h-31.06v21.9h-5.27v-47.91Z"
		/>
		<path
			className="fill-mint-100"
			d="M692.79,90.58c0-10.99,8.06-19.05,19.49-19.05s19.34,8.06,19.34,19.05v1.61h-33.77c.66,7.55,6.3,12.89,14.43,12.89,5.71,0,10.11-2.34,12.45-6.52h5.35c-2.78,6.67-9.38,11.06-17.8,11.06-11.43,0-19.49-8.06-19.49-19.05ZM726.49,87.8c-1.17-7.33-6.89-11.72-14.21-11.72s-13.19,4.62-14.29,11.72h28.5Z"
		/>
		<path
			className="fill-mint-100"
			d="M734.62,90.8c0-11.28,8.06-19.27,19.49-19.27s19.41,7.84,19.41,19.27v17.88h-4.54v-8.94c-2.56,6.45-8.57,9.89-15.6,9.89-10.18,0-18.75-7.25-18.75-18.83ZM768.61,90.58c0-8.35-5.86-14.5-14.5-14.5s-14.5,6.15-14.5,14.5,5.86,14.5,14.5,14.5,14.5-6.15,14.5-14.5Z"
		/>
		<path
			className="fill-mint-100"
			d="M779.74,56.66h4.91v52.01h-4.91v-52.01Z"
		/>
		<path
			className="fill-mint-100"
			d="M791.02,95.34v-35.68h4.91v12.82h21.32v4.47h-21.32v18.39c0,6.59,3.66,9.74,9.3,9.74s9.3-3.08,9.3-9.74v-.81h4.76v.81c0,9.52-5.71,14.29-14.07,14.29s-14.21-4.76-14.21-14.29Z"
		/>
		<path
			className="fill-mint-100"
			d="M822.96,56.66h4.91v22.86c2.56-5.2,7.4-7.99,13.7-7.99,9.67,0,17.14,5.86,17.14,18.24v18.9h-4.91v-18.9c0-8.94-5.13-13.7-12.97-13.7s-12.97,4.91-12.97,13.7v18.9h-4.91v-52.01Z"
		/>
		<path
			className="fill-mint-100"
			d="M883.76,60.77h5.27v43.08h29.01v4.83h-34.28v-47.91Z"
		/>
		<path
			className="fill-mint-100"
			d="M920.67,61.72c0-2.12,1.61-3.74,3.74-3.74s3.74,1.61,3.74,3.74-1.61,3.74-3.74,3.74-3.74-1.61-3.74-3.74ZM921.99,72.49h4.91v36.19h-4.91v-36.19Z"
		/>
		<path
			className="fill-mint-100"
			d="M932.27,89.78c0-12.01,7.18-18.24,17.88-18.24s17.87,6.23,17.87,18.24v18.9h-4.91v-18.9c0-8.94-5.13-13.7-12.97-13.7s-12.97,4.76-12.97,13.7v18.9h-4.91v-18.9Z"
		/>
		<path
			className="fill-mint-100"
			d="M973.78,56.66h4.91v32.01l19.19-16.19h6.89l-20.88,17.58,21.61,18.61h-6.96l-19.85-17.22v17.22h-4.91v-52.01Z"
		/>
		<path
			className="fill-mint-100"
			d="M137.85,73.09l-40.65-40.65c-6.75-6.75-17.73-6.75-24.47,0l-40.65,40.65c-6.75,6.75-6.75,17.73,0,24.47l40.65,40.65c6.75,6.75,17.73,6.75,24.47,0l40.65-40.65c6.75-6.75,6.75-17.73,0-24.47ZM54.88,67.71l12.48-12.48c2.51-2.51,6.59-2.51,9.1,0,2.51,2.51,2.51,6.59,0,9.1l-12.48,12.48c-2.51,2.51-6.59,2.51-9.1,0-2.51-2.51-2.51-6.59,0-9.1ZM89.05,128.96c-2.51,2.51-6.59,2.51-9.1,0l-38.61-38.61c-2.51-2.51-2.51-6.59,0-9.1,2.51-2.51,6.59-2.51,9.1,0l14.75,14.75,21.47-21.47c2.51-2.51,6.59-2.51,9.1,0,2.51,2.51,2.51,6.59,0,9.1l-21.47,21.47,14.75,14.75c2.51,2.51,2.51,6.59,0,9.1ZM115.06,102.94l-12.48,12.48c-2.51,2.51-6.59,2.51-9.1,0-2.51-2.51-2.51-6.59,0-9.1l12.48-12.48c2.51-2.51,6.59-2.51,9.1,0,2.51,2.51,2.51,6.59,0,9.1ZM128.6,89.4c-2.51,2.51-6.59,2.51-9.1,0l-38.61-38.61c-2.51-2.51-2.51-6.59,0-9.1,2.51-2.51,6.59-2.51,9.1,0l38.61,38.61c2.51,2.51,2.51,6.59,0,9.1Z"
		/>
		<path
			className="fill-navy-100"
			d="M163.17,61.43h35.29v8.71h-25.92v10.69h21.67v8.35h-21.67v11.49h25.92v8.64h-35.29v-47.88Z"
		/>
		<path
			className="fill-navy-100"
			d="M201.76,88.66c0-11.35,6.59-16.47,15.15-16.47,5.42,0,9.88,2.27,12.52,6.52,2.56-4.25,7.03-6.52,12.52-6.52,8.57,0,15.15,5.12,15.15,16.47v20.65h-8.71v-20.65c0-5.93-3.08-8.35-7.32-8.35s-7.25,2.49-7.25,8.35v20.65h-8.71v-20.65c0-5.86-3.15-8.35-7.32-8.35s-7.32,2.42-7.32,8.35v20.65h-8.71v-20.65Z"
		/>
		<path
			className="fill-navy-100"
			d="M260.65,91.52c0-11.71,7.91-19.33,19.25-19.33s19.55,7.91,19.55,19.4c0,12.37-9.23,18.67-18.01,18.67-5.2,0-9.52-2.2-12.08-6.22v20.72h-8.71v-33.24ZM290.67,91.22c0-6.37-4.32-10.91-10.69-10.91s-10.62,4.54-10.62,10.91,4.25,10.91,10.62,10.91,10.69-4.54,10.69-10.91Z"
		/>
		<path
			className="fill-navy-100"
			d="M302.6,91.22c0-10.98,8.05-19.04,19.47-19.04s19.47,8.05,19.47,19.04-8.05,19.03-19.47,19.03-19.47-8.05-19.47-19.03ZM332.69,91.22c0-6.37-4.25-10.91-10.62-10.91s-10.69,4.54-10.69,10.91,4.32,10.91,10.69,10.91,10.62-4.54,10.62-10.91Z"
		/>
		<path
			className="fill-navy-100"
			d="M339.43,70.31c0-5.48,4.03-9.51,9.73-9.51s9.73,4.03,9.73,9.51-4.03,9.51-9.73,9.51-9.73-4.03-9.73-9.51ZM356.77,70.31c0-4.34-3.08-7.5-7.61-7.5s-7.61,3.16-7.61,7.5,3.05,7.5,7.61,7.5,7.61-3.16,7.61-7.5ZM345.44,65.78h4.73c2.01,0,3.24,1.23,3.24,3.02,0,1.4-.7,2.49-2.1,2.91l2.41,3.13h-2.49l-2.01-2.97h-1.68v2.97h-2.1v-9.06ZM349.95,70.09c.92,0,1.31-.53,1.31-1.26s-.39-1.23-1.31-1.23h-2.41v2.49h2.41Z"
		/>
	</svg>
)
